import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigService } from '../../../../../helpers/config.service';
import { CompaniesService } from '../../../services/companies.service';

@Component({
  selector: 'app-employees-list',
  templateUrl: './employees-list.component.html',
  styles: ``
})
export class EmployeesListComponent implements OnInit {

  loadingDepartemtents: boolean = false;
  loadingEmployees: boolean = false;

  search: string = ''

  DepartementsList: any[] = []
  constructor(public dialogRef: MatDialogRef<EmployeesListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _config: ConfigService,
    private _companyService: CompaniesService) {

  }

  ngOnInit(): void {
    this.GetDepartements()
  }


  GetDepartements() {
    this.loadingDepartemtents = true;
    let model = { reward_id: this.data.id, search: this.search }
    this._companyService.GetCompanyDepartementsWithSearch(model).subscribe({
      next: (res) => {
        this.loadingDepartemtents = false;
        this.DepartementsList = res.data;
      },
      error: (error) => {
        this.loadingDepartemtents = false;

      }
    })
  }


  GetEmployees(DepartementID: string, index: number) {
    this.DepartementsList[index].loading = true;
    let model = {
      reward_id: this.data.id,
      department_id: DepartementID,
      search: this.search
    }
    this._companyService.GetCompanyEmployeesWithSearch(model).subscribe({
      next: (res) => {
        this.DepartementsList[index].loading = false;
        this.DepartementsList[index].list_employees = res.data;
      },
      error: (error) => {
        this.DepartementsList[index].loading = false;

      }
    })
  }

  // SHOW & HIDE DEPARTMENTS
  showDepartments(index: number) {
    this.DepartementsList[index].show = !this.DepartementsList[index].show
  }


}
